import React from 'react';
import firebase from './config/firebase.js'

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import 'bootstrap/dist/css/bootstrap.min.css';


import './App.css';

class App extends React.Component {
  constructor() {
    super()
    this.state = {
      // TODO:['VALUE1','VALUE2','VALUE3'],
      TODO: [],
      value: '',


    }
    this.add_todo = this.add_todo.bind(this)  //for bind fnction or this function also create arrow function
    this.show_all_todo = this.show_all_todo.bind(this)
    // this.componentDidMount.bind(this);

  }

  // componentDidMount = () => {

  //   console.log(this.state.TODO)
  //   var arr = []

  //   var leadsRef = firebase.database().ref('TODO_Data');
  //   leadsRef.on('value', function (snapshot) {
  //     snapshot.forEach(function (childSnapshot) {
  //       var childData = childSnapshot.val();
  //       console.log(childData)
  //       arr.push(childData)


  //     });


  //   });
  //   console.log(this.state.TODO)





  //   console.log("good")


  // }

  add_todo() {

    // console.log(this.state.value)
    // this.state.TODO.push(this.state.value)
    // console.log(this.state.TODO)

    // this.setState({
    //   ////This Function Run for Run RENDER
    //   TODO:this.state.TODO,
    //   value:''
    // })


    var chk = this.state.value
    console.log("Check :",chk)

    if(chk == ''){
      alert("Please Enter Todo value")
    }
    else{
      
    var key = Math.random() * 10000000
    console.log(key)
    key = key.toFixed()
    var obj = {
      title: this.state.value,
      key: key

    }
    firebase.database().ref('TODO_Data/' + key).set(obj)



    this.setState({
      TODO: [...this.state.TODO, obj],
      value: '',

    })

  }
    }



  all_del_todo = () => {
    firebase.database().ref('TODO_Data/').remove()
    this.setState({
      TODO: []
    })
  }

  delete_todo = (index, key) => {
    console.log(index, key)
    firebase.database().ref('TODO_Data/' + key).remove()
    this.state.TODO.splice(index, 1)
    this.setState({
      TODO: this.state.TODO
    })


  }

  edit_todo = (index, value, key) => {

    console.log(key)

    var update_val = prompt("Enter value", this.state.TODO[index].title)
    this.state.TODO[index].title = update_val
    this.setState({
      TODO: this.state.TODO
    })

    console.log(index, value)

    var obj = {
      title: update_val,
      key: key
    }

    firebase.database().ref('TODO_Data/' + key).set(obj)






    // this.state.TODO[index].edit=true;


    this.setState({
      TODO: this.state.TODO
    })

  }

  handleChange = (e, index) => {
    // console.log(e.target.value,``,index)
    this.state.TODO[index].title = e.target.value
    this.setState({
      TODO: this.state.TODO
    })

  }

  // update_todo = (index) =>{
  //   console.log(index)
  //   this.state.TODO[index].edit=false;
  //   this.setState({
  //     TODO:this.state.TODO
  //   })
  // }


  show_all_todo = () => {
    console.log("TODO DATA :", this.state.TODO)
    var arr = []
    firebase.database().ref('TODO_Data').once('value', function (data) {
      console.log(data.val())

      var zub = data.val()
      console.log("start")


      console.log("LENGTH OF OBJECT :", Object.keys(zub).length)
      var objlen = Object.keys(zub).length
      var key = ''
      var value = ''
      var obj = ''

      for (var i = 0; i < objlen; i++) {
        key = Object.values(zub)[i]['key']
        value = Object.values(zub)[i]['title']
        console.log(`Key :` + key + ` Value : ` + value)



        obj = {
          title: value,
          key: key,
        }
        arr.push(obj)
      }


      console.log("OBJECT", obj)
      console.log("ARRAY", arr)





      // console.log("TODO DATA :",this.state.TODO)
      // console.log(this.state.TODO)
      // this.setState({
      //   TODO:this.state.TODO.push(arr)
      // })
      // this.setState({
      //   TODO:this.state.TODO.push(arr) 
      // }) 



    }

    )




  }







  render() {
    let { TODO, value } = this.state
    return (
      <div >
        <div className='container-fluid'>

          <div className='row' style={{ backgroundColor: 'red', color: 'white' }}>
            <div className='col col-lg-12 col-md-12 col-sm-12 col-12'>

              <h1 className='text-center'>REACT TODO APP </h1>
            </div>

          </div>
          <br />
          <div className='row'>
            <div className='col col-lg-2 col-md-2 col-sm-1 col-1 md-none'>


            </div>


            <div className='col col-lg-8 col-sm-9 col-md-9 col-10 ' style={{ backgroundColor: 'white' }}>
              <br />
              <div className='row'>
                <div className='col col-lg-6 col-md-12 col-sm-12 col-12'>
                  <TextField id="outlined-basic" label="Enter Todo Item" style={{ width: '100%' }} variant="outlined" value={value} placeholder="Enter Todo Item" onChange={(e) => this.setState({ value: e.target.value })} />

                </div>
                <div className='col col-lg-2 md'>
                  <Button variant="contained" color="primary" style={{ width: '100%', height: '50px' }} onClick={this.add_todo} >
                    ADD ITEM
    </Button>


                </div>
                <div className='col col-lg-2 md'>
                  {/* <button onClick={this.add_todo}>ADD ITEM</button> */}
                  <Button variant="contained" color="primary" style={{ width: '100%', height: '50px' }} onClick={this.all_del_todo} >
                    DELETE ITEM
    </Button>


                </div>
                <div className='col col-lg-2 md'>
                  {/* <button onClick={this.all_del_todo}>DELETE ITEM</button> */}
                  <Button variant="contained" color="primary" style={{ width: '100%', height: '50px' }} onClick={this.show_all_todo}  >
                    SHOW ITEM
    </Button>


                </div>
              </div>



              {/* <input value={value} type="text" placeholder="Enter Text" onChange={(e)=>this.setState({value:e.target.value})}/> */}


              {/* <button onClick={this.show_all_todo}>SHOW ITEM</button> */}
              <ul>
              
                <div className='row'>
                  <br/>
                  <div className='col  col-lg-12' style={{marginTop:'2%'} }>


                    
                      

                   

                    {TODO.map((v, i) => {
                      

                      return <li key={i}  >
                        {v.edit
                          ? <input value={v.title} type="text" onChange={(e) => this.handleChange(e, i)} />
                          : v.title
                        }





                        
                          <Button variant="contained" style={{backgroundColor:'green'}} onClick={() =>  { this.edit_todo(i, v.title, v.key) }}  id='edit'>Edit</Button>
                        
                          
                       
                          <Button variant="contained" color='secondary' onClick={() => { this.delete_todo(i, v.key) }} id='delic' >Delete</Button>
                          </li>

                })}
                
               

             


                </div>

              </div>
              </ul>

              
             

            </div>

            </div>
            <div className='col col-lg-2 col-md-2 col-sm-0 col-0 md-none'>


            </div>



          </div>
        </div>
   

    )
  }
}

export default App;
